<!--
@component

A clickable item within a context menu that triggers some action.
```svelte
<ContextMenuItem icon="plus" variant="danger" label="click me!" />
```
-->
<svelte:options immutable />

<script lang="ts">
import type { ClassValue } from 'svelte/elements';

import { Icon, type IconName } from '../icon';
import type { ContextMenuItemVariant } from './variants';

/**
 * Optional icon name shown in the item.
 */
export let icon: IconName | undefined = undefined;

/** The style variant, default value is 'primary' */
export let variant: ContextMenuItemVariant = 'primary';

/** Additional CSS classes to pass to the item. */
let extraClasses: ClassValue = '';
export { extraClasses as cx };
</script>

<button
  type="button"
  role="menuitem"
  class={[
    'hover:bg-light flex w-full items-center gap-1.5 px-3 py-1.5 text-left',
    extraClasses,
  ]}
  on:click
>
  {#if icon}
    <div
      class={[
        {
          'text-gray-400': variant === 'primary',
          'text-danger-dark': variant === 'danger',
        },
      ]}
    >
      <Icon name={icon} />
    </div>
  {/if}

  <p
    class={[
      'text-sm',
      {
        'text-default': variant === 'primary',
        'text-danger-dark': variant === 'danger',
      },
    ]}
  >
    <slot />
  </p>
</button>
